"use client";

import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/lib/query-client";
import { fetchTopListingsForHomeRpc } from "@/lib/home/home-public-rpc";
import { useAuth } from "@/hooks/use-auth";


export function useTopListingsForHome(limit = 4) {
  const { user } = useAuth();
  return useQuery({
    queryKey: queryKeys.home.topListings(limit, user?.id ?? null),
    queryFn: () => fetchTopListingsForHomeRpc(limit, user?.id),
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: false,
    placeholderData: (previousData) => previousData,
  });
}
